import { render, staticRenderFns } from "./NoRecordsYet.vue?vue&type=template&id=15d67a1d&scoped=true&"
import script from "./NoRecordsYet.vue?vue&type=script&lang=js&"
export * from "./NoRecordsYet.vue?vue&type=script&lang=js&"
import style0 from "./NoRecordsYet.vue?vue&type=style&index=0&id=15d67a1d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d67a1d",
  null
  
)

export default component.exports